import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Page, Pages, Question, Questions } from "@types-runway/questionnaire";
import sections from "@utils/questionnaire/questionsPages.json";

// Extract all stateKeys from QuestionsPages
const initialState: Questions = {};
const initialQuestionPayload: Question = {
  question: "",
  answer: "",
  type: "string",
  important: false,
};

Object.values(sections).forEach((section) => {
  if (Array.isArray((section as Pages).pages)) {
    (section as Pages).pages.forEach((page: Page) => {
      if (page.stateKey) {
        initialState[page.stateKey] = {
          ...initialQuestionPayload,
          question: page.question,
          answer: page.answer ?? "",
        };
      }
    });
  }
});

const questionnaireSlice = createSlice({
  name: "questionnaire",
  initialState,
  reducers: {
    updateQuestion: (state, action: PayloadAction<{ stateKey: string; question: Question }>) => {
      const { stateKey, question } = action.payload;
      if (stateKey) {
        state[stateKey] = question;
      }
    },
    loadForm: (state, action: PayloadAction<Question[]>) => {
      const questionTitles = action.payload.map((question) => question.question);

      const questions = state as Questions;

      Object.keys(questions).forEach((stateKey: string) => {
        const answerIndex = questionTitles.indexOf(questions[stateKey].question);
        if (answerIndex > -1) {
          state[stateKey] = action.payload[answerIndex];
        }
      });
    },
    clearForm: () => {
      return initialState;
    },
  },
});

export const { updateQuestion, clearForm, loadForm } = questionnaireSlice.actions;
export default questionnaireSlice.reducer;
